import { FactorType } from "types/notification";

export const notificationFactorGroupBy = (key: string, data?: FactorType[]) => {  
  if(!data)return
  const elementsOfGroup = data.filter(element => element.element === key)
  return elementsOfGroup
}